import React from 'react';
import PropTypes from 'prop-types';

const ChatPanel = ({ children, whatsAppAvailable }) => {
  return (
    <div className="ch-align-items--center ch-display--flex ch-flex--auto ch-bt--1 ch-bc--grey-3 ch-flex-flow--column-nowrap md:ch-flex-flow--row-nowrap">
      <div className="md:ch-text--left md:ch-width--7 ch-display--flex ch-flex-flow--column-wrap ch-pt--1 ch-ph--2 md:ch-pa--3">
        <p className="ch-fs--3 ch-mb--0 ch-mt--2 md:ch-mt--0 ch-text--bold">
          Chat with us
        </p>
        <p className="ch-mb--1">
          You can message us on{' '}
          {whatsAppAvailable && (
            <span className="sm:ch-display--none">WhatsApp or </span>
          )}
          our web chat.
        </p>
      </div>
      <div className="ch-display--flex ch-flex-flow--row-wrap ch-width--12 md:ch-width--5 ch-align-items--center ch-pa--1">
        {children}
      </div>
    </div>
  );
};

ChatPanel.propTypes = {
  children: PropTypes.node,
  whatsAppAvailable: PropTypes.bool,
};

export default ChatPanel;
